import React from 'react';
import SecuredZone from '../SecuredZone/SecuredZone';
import Dialog from '@material-ui/core/Dialog';
import API from '../../../api/api';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getImageUrl } from '../../../utils/imageUtils';
import { Component } from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
  Chip
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import AdminGalleryDialog from '../../../dialogs/admin-gallery/admin-gallery';
import AdminGalleryImagesDialog from '../../../dialogs/admin-gallery-images/admin-gallery-images';

const garageApi = new API();

class AdminGallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      adminGalleryDialog: false,
      adminGalleryImagesDialog: false,
      galleries: [],
      editGalleryItem: {},
      selectedGalleryId: null,
    };
  }

  componentDidMount() {
    this.loadGallery();
  }

  loadGallery() {
    garageApi.endpoints.gallery.getAll()
      .then((getRequest) => {
        try {
          // API gibt direkt ein Array zurück, nicht in results
          const galleries = Array.isArray(getRequest.data) ? getRequest.data : (getRequest.data?.results || []);
          this.setState({ galleries: galleries, loading: false });
          
          // Lade für jede Galerie das erste Bild als Thumbnail
          galleries.forEach((gallery) => {
            if (gallery.id && gallery.image_count > 0) {
              this.loadGalleryThumbnail(gallery.id, gallery.unikey);
            }
          });
        } catch(e) {
          console.log(e);
          this.setState({ galleries: [], loading: false });
        }
      })
      .catch(() => {
        this.setState({ galleries: [], loading: false });
      });
  }

  loadGalleryThumbnail(galleryId, galleryUnikey) {
    garageApi.endpoints.gallery.getOne({ id: galleryId })
      .then((response) => {
        try {
          console.log('Thumbnail response for gallery', galleryId, ':', response);
          if (response.data && response.data.images && response.data.images.length > 0) {
            const firstImage = response.data.images[0];
            console.log('First image for thumbnail:', firstImage);
            this.setState(prevState => ({
              galleries: prevState.galleries.map(gallery => 
                gallery.unikey === galleryUnikey 
                  ? { ...gallery, thumbnailImage: firstImage }
                  : gallery
              )
            }));
          } else {
            console.log('No images found for gallery', galleryId);
          }
        } catch(e) {
          console.error('Error loading thumbnail:', e);
        }
      })
      .catch((error) => {
        console.error('Error loading gallery thumbnail:', error);
        console.error('Error response:', error.response);
      });
  }

  deleteGallery(unikey) {
    if (!window.confirm('Möchten Sie diese Galerie wirklich löschen? Alle Bilder in der Galerie werden ebenfalls entfernt.')) {
      return;
    }

    var deleteItem = this.state.galleries.find((element) => { return element.unikey === unikey; });
    if (!deleteItem) return;

    this.setState({ loading: true });

    garageApi.endpoints.gallery.delete({ id: deleteItem.id })
      .then(() => {
        this.loadGallery();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  closeAdminGalleryDialog() {
    this.setState({ 
      adminGalleryDialog: false, 
      editGalleryItem: {},
      adminGalleryImagesDialog: false // Stelle sicher, dass der Bilder-Dialog auch geschlossen ist
    });
  }

  closeAdminGalleryImagesDialog() {
    // Stelle sicher, dass nur der Bilder-Dialog geschlossen wird, nicht der Galerie-Dialog
    this.setState({ 
      adminGalleryImagesDialog: false, 
      selectedGalleryId: null
    });
  }

  submitAdminGalleryDialog(mode, galleryItem) {
    this.setState({ loading: true });
    if(mode) {
      garageApi.endpoints.gallery.create(galleryItem)
        .then(() => {
          this.loadGallery();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } else {
      garageApi.endpoints.gallery.update(galleryItem)
        .then(() => {
          this.loadGallery();
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
    this.setState({ adminGalleryDialog: false, editGalleryItem: {} });
  }

  openAddImagesDialog(galleryId) {
    // Stelle sicher, dass der Galerie-Dialog geschlossen ist
    this.setState({ 
      adminGalleryImagesDialog: true, 
      selectedGalleryId: galleryId,
      adminGalleryDialog: false,
      editGalleryItem: {}
    });
  }

  editGallery(unikey) {
    var editItem = this.state.galleries.find((element) => { return element.unikey === unikey; });
    this.setState({ editGalleryItem: editItem || {}, adminGalleryDialog: true });
  }

  createGallery() {
    this.setState({ editGalleryItem: {}, adminGalleryDialog: true });
  }

  render() {
    const { loading, galleries, adminGalleryDialog, adminGalleryImagesDialog, editGalleryItem, selectedGalleryId } = this.state;

    return (
      <SecuredZone
        breadcrumbs={{ '/admin/': 'Dashboard', '/admin/gallery': 'Galerie' }}
        menu={{ 'Galerie Erstellen': this.createGallery.bind(this) }}
        title="Galerie"
        loading={loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
      >
        <Dialog 
          open={adminGalleryDialog} 
          onClose={this.closeAdminGalleryDialog.bind(this)}
          maxWidth="sm"
          fullWidth
        >
          <AdminGalleryDialog 
            galleryData={editGalleryItem} 
            close={this.closeAdminGalleryDialog.bind(this)} 
            submit={this.submitAdminGalleryDialog.bind(this)}
          />
        </Dialog>

        <Dialog 
          open={adminGalleryImagesDialog} 
          onClose={this.closeAdminGalleryImagesDialog.bind(this)}
          maxWidth="md"
          fullWidth
        >
          <AdminGalleryImagesDialog 
            galleryId={selectedGalleryId}
            close={this.closeAdminGalleryImagesDialog.bind(this)}
          />
        </Dialog>
        
        {!loading && (
          <Box style={{ padding: '20px' }}>
            {/* Statistik */}
            <Paper elevation={2} style={{ padding: '20px', marginBottom: '24px', background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" style={{ fontWeight: 700, marginBottom: '8px' }}>
                    {galleries.length}
                  </Typography>
                  <Typography variant="body1" style={{ opacity: 0.9 }}>
                    {galleries.length === 1 ? 'Galerie' : 'Galerien'}
                  </Typography>
                </Box>
                <PhotoLibraryIcon style={{ fontSize: 60, opacity: 0.3 }} />
              </Box>
            </Paper>

            {/* Galleries Grid */}
            {galleries.length > 0 ? (
              <Grid container spacing={3}>
                {galleries.map((gallery) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={gallery.unikey}>
                    <Card 
                      style={{ 
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        backgroundColor: '#f5f5f5',
                        minHeight: '250px',
                        overflow: 'hidden'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                      }}
                    >
                      {gallery.thumbnailImage && (() => {
                        const thumbnailUrl = getImageUrl(gallery.thumbnailImage.image, 'medium');
                        console.log('Thumbnail URL for gallery', gallery.title, ':', thumbnailUrl);
                        return thumbnailUrl ? (
                          <CardMedia
                            style={{ 
                              height: '150px',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundImage: `url(${thumbnailUrl})`,
                              backgroundColor: '#e0e0e0'
                            }}
                          />
                        ) : null;
                      })()}
                      <CardContent style={{ 
                        flexGrow: 1, 
                        position: 'relative', 
                        padding: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                      }}>
                        <Typography 
                          variant="h6" 
                          component="h3" 
                          style={{ 
                            fontWeight: 600, 
                            marginBottom: '8px',
                            minHeight: '28px'
                          }}
                        >
                          {gallery.title || 'Ohne Titel'}
                        </Typography>
                        {gallery.description && (
                          <Typography 
                            variant="body2" 
                            color="textSecondary"
                            style={{ 
                              marginBottom: '12px',
                              flexGrow: 1
                            }}
                          >
                            {gallery.description}
                          </Typography>
                        )}
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ marginTop: 'auto' }}>
                          <Chip 
                            label={`${gallery.image_count || 0} ${(gallery.image_count || 0) === 1 ? 'Bild' : 'Bilder'}`}
                            size="small"
                            color="primary"
                            variant="outlined"
                          />
                          <Box display="flex" gap="4px">
                            <Tooltip title="Bilder hinzufügen">
                              <IconButton 
                                size="small" 
                                onClick={(e) => { 
                                  e.stopPropagation();
                                  if (gallery.id) {
                                    this.openAddImagesDialog(gallery.id);
                                  } else {
                                    console.error('Gallery ID fehlt:', gallery);
                                    alert('Fehler: Galerie-ID fehlt. Bitte Seite neu laden.');
                                  }
                                }}
                                style={{ color: '#1976d2', padding: '4px' }}
                              >
                                <AddPhotoAlternateIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Bearbeiten">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.editGallery(gallery.unikey); }}
                                style={{ color: '#1976d2', padding: '4px' }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Löschen">
                              <IconButton 
                                size="small" 
                                onClick={() => { this.deleteGallery(gallery.unikey); }}
                                style={{ color: '#d32f2f', padding: '4px' }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Paper elevation={2} style={{ padding: '60px', textAlign: 'center' }}>
                <PhotoLibraryIcon style={{ fontSize: 80, color: '#ccc', marginBottom: '20px' }} />
                <Typography variant="h6" color="textSecondary" style={{ marginBottom: '8px' }}>
                  Noch keine Galerien vorhanden
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Klicken Sie auf "Galerie Erstellen" um Ihre erste Galerie anzulegen.
                </Typography>
              </Paper>
            )}
          </Box>
        )}
      </SecuredZone>
    );
  }
}

export default AdminGallery;
